var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlayPanUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#313131"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 17,
    height: 17,
    rx: 1.5,
    fill: "#313131",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H16",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V16",
    stroke: "white",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L10.4828 16C10.3047 16 10.2154 16.2154 10.3414 16.3414L11.8586 17.8586C11.9367 17.9367 12.0633 17.9367 12.1414 17.8586L13.6586 16.3414C13.7846 16.2154 13.6953 16 13.5172 16L12 16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L10.4828 16C10.3047 16 10.2154 16.2154 10.3414 16.3414L11.8586 17.8586C11.9367 17.9367 12.0633 17.9367 12.1414 17.8586L13.6586 16.3414C13.7846 16.2154 13.6953 16 13.5172 16L12 16Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12L16 13.5172C16 13.6953 16.2154 13.7846 16.3414 13.6586L17.8586 12.1414C17.9367 12.0633 17.9367 11.9367 17.8586 11.8586L16.3414 10.3414C16.2154 10.2154 16 10.3047 16 10.4828L16 12Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12L16 13.5172C16 13.6953 16.2154 13.7846 16.3414 13.6586L17.8586 12.1414C17.9367 12.0633 17.9367 11.9367 17.8586 11.8586L16.3414 10.3414C16.2154 10.2154 16 10.3047 16 10.4828L16 12Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12L8 13.5172C8 13.6953 7.78457 13.7846 7.65858 13.6586L6.14142 12.1414C6.06332 12.0633 6.06332 11.9367 6.14142 11.8586L7.65858 10.3414C7.78457 10.2154 8 10.3047 8 10.4828L8 12Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12L8 13.5172C8 13.6953 7.78457 13.7846 7.65858 13.6586L6.14142 12.1414C6.06332 12.0633 6.06332 11.9367 6.14142 11.8586L7.65858 10.3414C7.78457 10.2154 8 10.3047 8 10.4828L8 12Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L10.4828 8C10.3047 8 10.2154 7.78457 10.3414 7.65858L11.8586 6.14142C11.9367 6.06332 12.0633 6.06332 12.1414 6.14142L13.6586 7.65858C13.7846 7.78457 13.6953 8 13.5172 8L12 8Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L10.4828 8C10.3047 8 10.2154 7.78457 10.3414 7.65858L11.8586 6.14142C11.9367 6.06332 12.0633 6.06332 12.1414 6.14142L13.6586 7.65858C13.7846 7.78457 13.6953 8 13.5172 8L12 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayPanUnlock);
export default __webpack_public_path__ + "static/media/OverlayPanUnlock.5cdf68750862f351d322232c6be927f4.svg";
export { ForwardRef as ReactComponent };